var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.currentData.id
          ? _vm.$t("addOrganDrug.drugDetail")
          : _vm.$t("addOrganDrug.addDrug"),
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        top: "6vh",
        width: "1000px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isVisible = $event
        },
        close: function ($event) {
          _vm.isVisible = false
        },
      },
    },
    [
      _c("avue-form", {
        attrs: { option: _vm.formOption },
        on: { submit: _vm.handleSubmit },
        scopedSlots: _vm._u([
          {
            key: "diagnoseList",
            fn: function () {
              return [
                _vm._l(_vm.formData.diagnoseList, function (item, index) {
                  return _c(
                    "el-tag",
                    {
                      key: item,
                      attrs: {
                        "disable-transitions": false,
                        closable: !_vm.currentData.id,
                      },
                      on: {
                        close: function ($event) {
                          return _vm.deleteDiagnose(index)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(item) + "\n      ")]
                  )
                }),
                _vm.inputVisible
                  ? _c("el-input", {
                      ref: "saveTagInput",
                      staticClass: "input-new-tag",
                      attrs: { size: "small" },
                      on: { blur: _vm.handleInputConfirm },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleInputConfirm($event)
                        },
                      },
                      model: {
                        value: _vm.diagnoseName,
                        callback: function ($$v) {
                          _vm.diagnoseName = $$v
                        },
                        expression: "diagnoseName",
                      },
                    })
                  : _vm._e(),
                !_vm.currentData.id && !_vm.inputVisible
                  ? _c(
                      "el-button",
                      {
                        staticClass: "button-new-tag",
                        attrs: { size: "small" },
                        on: { click: _vm.showInput },
                      },
                      [_vm._v("+ 添加诊断")]
                    )
                  : _vm._e(),
                _vm.currentData.id &&
                (!_vm.formData.diagnoseList ||
                  _vm.formData.diagnoseList.length == 0)
                  ? _c("div", [_vm._v("暂无诊断")])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.formData,
          callback: function ($$v) {
            _vm.formData = $$v
          },
          expression: "formData",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }